import { FC } from 'react';
import { GlacierWaveProps } from '../interface';
import B from './components/B';
import C from './components/C';
// import E from './components/E';
import { useGlobal } from '@/utils/useGlobal';

const Com: FC<GlacierWaveProps> = (props) => {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const CompB =
        props.curStage !== 1 ? (
            <></>
        ) : (
            <div className="treaser-part-wrapper">
                <B />
            </div>
        );

    return (
        <>
            {CompB}
            {/* {locale === 'kr' && <E />} */}
            <div className="treaser-part-wrapper">
                <C {...props} />
            </div>
            {/* <div className="teaser-part-wrapper">
                <D />
            </div> */}
        </>
    );
};

export default Com;
